import styled from "styled-components";
import { FloatWindowStyles } from "./promotionModalShared.styles";

export const FromXToYPromoFloatWindow = styled.div`
  ${FloatWindowStyles}
  height: 55rem;

  h1 {
    margin-bottom: 0;
  }

  h2 {
    font-size: 2.4rem;
  }

  button {
    margin-top: 2rem;
  }
`;
